export default "__VITE_ASSET__ClAyJ4OV__"